var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('van-nav-bar',{attrs:{"title":_vm.fileInfo.name,"left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"c"},_vm._l((_vm.fileInfo.files),function(file,index){return _c('div',{key:index,staticClass:"file-item"},[_c('FileItem',{attrs:{"file":file}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }